import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import withSizes from 'react-sizes';

import { Container, Row, Col } from "deltoid/core/Blocks/BootstrapContainers";
import { Card } from "deltoid/core/OneDashCards";

import VerifyOTP from "../../features/verify-otp";

import SignUpCMS from "../../features/prismic/SignUpCMS";
import SignInCMS from "../../features/prismic/SignInCMS";
import SignInPartnerCMS from "../../features/prismic/SignInPartnerCMS";

import config from "../../../shared/services/config";
import { sendOtp, verifyOtp, resetFetchUser } from "../../../shared/actions/auth";
import AuthManager from '../../../shared/services/AuthManager';
import { userFriendlyErrorMessage } from '../../../shared/utils/response';


const EmailonlyOTPVerification = (props) => {
    
    const { user } = props.history.location.state;
    const { otpData } = props;

    const [err, setError] = useState(null);
    const [retryTime, setRetryTime] = useState(60 * 1000);
    const [disableResend, setDisableResend] = useState(true);
    const [isPartner, setIsPartner] = useState(config.get('product') === 'PARTNER');

    useEffect(() => {
        sendMobileOtp();
    }, []);

    useEffect(() => {
        if (otpData && otpData.error) {
            setError(userFriendlyErrorMessage(otpData.error[0]))
        }
        else {
            setError(null);
        }
    }, [otpData])

    const sendMobileOtp = async () => {
        let params;
        if (user) {
            params = {
                channels: ['sms'],
                type: 'SignIn',
                identity: user && user.id,
                scope: config.get('loginScope', ''),
                token: AuthManager.getHubApiToken(),
                password_token: props.location.state.passwordToken,
            };
            await sendOtp(props.dispatch, {
                ...params,
                additional_payload: {
                    name: user.displayName,
                },
            });
        }
    }
    const onBack = () => {
        if (props.location.state.isLogin) {
            resetFetchUser(props.dispatch)
        }
        props.history.push({
            pathname: props.location.state.isLogin ? '/account/signin' : '/account/signup',
            state: {
                ...props.location.state,
                userEmail: props.location.state.isLogin ? '' : props.location.state?.userEmail,
            }
        });
    }

    const onSubmit = async (otp) => {
        if (otp && otp.length === 4) {
            const params = {
                identity: user.id,
                type: 'SignIn',
                code: otp,
                token: AuthManager.getHubApiToken(),
            };
            try {
                const res = await verifyOtp(props.dispatch, params);
                AuthManager.setAppToken();
                AuthManager.persistFullToken(res)
                const { state: historyState } = props.location;
                props.history.push({
                    pathname: '/account/email/verify',
                    state: {
                        ...props.location.state,
                    }
                });
            }
            catch (e) {
                console.log(e);
            }
        } else {
            setError('Please enter your complete  OTP');
        }
    };
    return (
        <Container fluid className='vector-bg login-max-width-container'>
            <Row>
                <Col md={6} className='p-0'>
                    {props.location.state.signup ? (isPartner ? <SignInPartnerCMS /> : <SignInCMS />) : <SignUpCMS />}
                </Col>
                <Col md={5} className={props.isMobile && 'm-0 p-0'}>
                    <div className={!props.isMobile && 'login-container mt-5 mx-4'}>
                        <Card>
                            <VerifyOTP
                                handleVerifyOTP={onSubmit}
                                otpLength={4}
                                mobile={user && user.mobile}
                                errMsg={err}
                                resendOtp={() => { setRetryTime(60 * 1000); setDisableResend(true); sendMobileOtp(); }}
                                retryTime={retryTime}
                                onTimerComplete={() => { setRetryTime(false); setDisableResend(false); }}
                                disableResend={disableResend}
                                onBack={onBack}
                                isMFAEnabled={props.location.state.isMFAEnabled}
                            />
                        </Card>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};


const mapDispatchToProps = (dispatch) => ({
    dispatch,
});

const mapStateToProps = (state) => {
    return {
        otpData: state.session.otpData,
        user: state.session.User
    };
};

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 768,
});

const Responsive = withSizes(mapSizesToProps)(EmailonlyOTPVerification);
export default connect(mapStateToProps, mapDispatchToProps)(Responsive);